import { render, staticRenderFns } from "./BannerZone.vue?vue&type=template&id=92a7ac84&scoped=true"
import script from "./BannerZone.vue?vue&type=script&lang=js"
export * from "./BannerZone.vue?vue&type=script&lang=js"
import style0 from "./BannerZone.vue?vue&type=style&index=0&id=92a7ac84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a7ac84",
  null
  
)

export default component.exports